import React from 'react'
import Icon from 'components/shared/Icon'
import Tooltip from 'components/shared/Tooltip'
import TooltipText from './TooltipText'

import iconPlay from 'assets/icons/ico-play.svg'
import iconPause from 'assets/icons/ico-pause.svg'

import { useSelector, useDispatch } from 'react-redux'
import { checkIsActivityPaused } from 'state/selectors'
import * as Actions from 'state/actions'


const PlayPauseButton = ( ) => {
  const isPaused = useSelector(checkIsActivityPaused)
  const dispatch = useDispatch()
    
  const togglePause = () => {
    if(!isPaused) return dispatch(Actions.savePause())
    if(isPaused) return dispatch(Actions.deletePause())
  }

  return (
    <Tooltip
      trigger={() => (
        <Icon
          onClick = {togglePause}
          src={
            isPaused
              ? iconPlay
              : iconPause
          }
        />
      )}
      type='arrow'
      position='top'
    >
      <TooltipText>{isPaused ? 'Unpause ' : 'Pause '}chatbot</TooltipText>
    </Tooltip>
  )
}

export default PlayPauseButton
